import { InfoIcon } from '@chakra-ui/icons';
import { Box, Tooltip } from '@chakra-ui/react';
import React, { useState } from 'react';

interface InfoTooltipProps {
    tooltipLabel: string;
    tooltipInfoText: string;
}
export default function InfoTooltip(props: InfoTooltipProps) {
    const [isOpen, setIsOpen] = useState(false);

    const open = () => setIsOpen(true);
    const close = () => setIsOpen(false);

    return (
        <Tooltip
            whiteSpace={'pre-wrap'}
            label={props.tooltipInfoText}
            aria-label={props.tooltipLabel}
            hasArrow
            isOpen={isOpen}
        >
            <Box
                as="span"
                style={{
                    padding: 0,
                    margin: 0,
                    marginLeft: '5px',
                    marginRight: '5px',
                }}
                _focus={{
                    outline: '3px solid #000000',
                    outlineOffset: 2,
                }}
                onFocus={open}
                onBlur={close}
                onMouseEnter={(e) => {
                    let span: Node = e.target as Node;

                    let i = 0;
                    while (span.nodeName !== 'SPAN' && span.parentNode !== null && i++ < 5) span = span.parentNode;
                    if (span.nodeName === 'SPAN' && span instanceof HTMLDivElement) span.focus();
                }}
                role={'note'}
                aria-label={`${props.tooltipLabel}: ${props.tooltipInfoText}`}
                tabIndex={0}
            >
                <InfoIcon
                    width={'20px'}
                    height={'20px'}
                    verticalAlign={'middle'}
                    padding={0}
                    color="blue.500"
                    margin={0}
                    aria-hidden={'true'}
                />
            </Box>
        </Tooltip>
    );
}
